import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class ActionService {

    sideNavDisplay: Subject<any> = new Subject<any>();

    constructor() {}

    /**
     * Use to change sidenav display
     * @data type: string
     */
    sideNavDisplayChange(data: boolean) {
        this.sideNavDisplay.next(data);
    }
}